import useMediaQuery from "@mui/material/useMediaQuery";
export const useSmallDevice = () => useMediaQuery("(max-width: 599px)");
